"use client";
import Image from "next/image";
import { GlareCard } from "../ui/glare-card";
import { Calendar } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import AnimationContainer from "../utils/animation-container";

const blogPosts = [
  {
    id: 1,
    title: "بهترین روش خرید UC پابجی با کمترین هزینه",
    excerpt:
      "در این مقاله راهکارهای خرید یوسی پابجی با قیمت مناسب را بررسی می‌کنیم و به شما کمک می‌کنیم تا سریع‌تر از همیشه پیشرفت کنید!",
    image: "/images/pubg.jpg",
    date: "10 اسفند 1402",
  },
  {
    id: 2,
    title: "راهنمای خرید گیفت کارت پلی استیشن برای گیمرها",
    excerpt:
      "آیا می‌دانید چطور یک گیفت کارت پلی استیشن مناسب بخرید؟ ما بهترین روش‌های خرید و استفاده از گیفت کارت را توضیح داده‌ایم.",
    image: "/images/ps.jpg",
    date: "15 اسفند 1402",
  },
  {
    id: 3,
    title: "معرفی بهترین بازی‌های آنلاین برای رقابت با دوستان",
    excerpt:
      "اگر به دنبال بازی‌های آنلاین هیجان‌انگیز برای رقابت با دوستان خود هستید، در این مقاله بهترین‌ها را به شما معرفی می‌کنیم.",
    image: "/images/games.jpg",
    date: "20 اسفند 1402",
  },
  {
    id: 4,
    title: "چطور استیم والت را به درستی فعال کنیم؟",
    excerpt:
      "راهنمای جامع فعال‌سازی استیم والت و استفاده از آن برای خرید بازی‌های استیم با بهترین قیمت در سایت بازی تور در دسترس شماست.",
    image: "/images/steam.jpg",
    date: "25 اسفند 1402",
  },
];

const Blogposts = () => {
  return (
    <div className="w-full h-full">
      <AnimationContainer delay={0.5}>
        <div className="mb-3 flex flex-col gap-2">
          <h1 className="font-medium text-[24px]">آخرین مطالب بلاگ</h1>
          <p className="text-[13px] text-gray-400">
            جدیدترین مقالات، راهنماها و اخبار دنیای بازی‌ها
          </p>
        </div>

        <div>
          <Swiper
            loop={true}
            grabCursor={true}
            breakpoints={{
              0: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            }}
          >
            {blogPosts.map((post) => (
              <SwiperSlide key={post.id} className="flex justify-center items-center">
                <div className="flex flex-col gap-2 p-4 rounded-xl duration-500 cursor-pointer">
                  <GlareCard className="rounded-xl" scale={0.95}>
                    <Image
                      src={post.image}
                      width={500}
                      height={400}
                      alt={post.title}
                      className="rounded-xl"
                    />
                  </GlareCard>
                  <div className="flex flex-col gap-5">
                    <div className="flex flex-col gap-2">
                      <p className="text-[17px] font-semibold">{post.title}</p>
                      <p className="text-[14px] text-gray-400 text-justify">
                        {post.excerpt}
                      </p>
                    </div>
                    <div className="w-full flex items-end justify-end gap-1 text-[14px]">
                      <div className="w-1/2 flex gap-2 items-center text-gray-300">
                        <Calendar size={22} />
                        <p className="text-[14px]">{post.date}</p>
                      </div>
                      <div className="w-1/2 flex justify-end">
                      <p className="text-white bg-gradient-to-r from-purple-500 to-purple-900 px-3 py-[1px] rounded-full">
                        ادامه مطالب
                      </p>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </AnimationContainer>
    </div>
  );
};

export default Blogposts;
